import ApiClient from './ApiClient';


export const fetchCompanies = (params: any) => {
    return ApiClient.get('company/', { params })
        .then( response => {
            if(response){
                return response.data
            }
            return false
        })
}

export const updateCompany = (companyId: any, payload: any) => {
    return ApiClient.put(`company/${companyId}`, payload)
        .then( response => {
            if(response){
                return response.data
            }
            return false
        })
}

export const getCompanySubs = (companyId: any) => {
    return ApiClient.get(`company/${companyId}/notifications`)
        .then( response => {
            if(response){
                return response.data
            }
            return false
        })
}


export const createCompany = (payload: any) => {
  return ApiClient.post(`company/admin/create`, payload)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
}

export const fetchCompaniesByRole = () => {
  return ApiClient.get(`company/admin/list`)
    .then(response => {
      if (response) {
        return response.data
      }
      return false
    })
}

export const fetchCompanyPeopleList = (companyId: string) => {
  return ApiClient.get(`auth0/users?companyId=${companyId}`)
    .then(response => {
      if (response) {
        return response.data;
      }
      return false;
    });
};